import React from "react";
import PropTypes from "prop-types";

import {
  ContainerCircle,
  ContainerGradient,
  ContainerGreenBack,
  ContainerMain,
  ContainerMainCustom,
  ContainerNumber,
  FirstColor,
  SecondColor,
  TextNumberOption,
} from "./styles";

const CardInfoOption = ({ firstColor, secondColor, number, children, press, custom }) => {
  return custom ? (
    <ContainerMainCustom onClick={press} style={{ height: "150px" }}>
      <ContainerGradient>
        <ContainerNumber>
          <ContainerCircle>
            <FirstColor style={{ backgroundColor: firstColor }} />
            <SecondColor style={{ backgroundColor: secondColor }} />
          </ContainerCircle>
          <TextNumberOption>{number}</TextNumberOption>
        </ContainerNumber>
        {children}
      </ContainerGradient>
      <ContainerGreenBack style={{ backgroundColor: firstColor }} />
    </ContainerMainCustom>
  ) : (
    <ContainerMain onClick={press}>
      <ContainerGradient>
        <ContainerNumber>
          <ContainerCircle>
            <FirstColor style={{ backgroundColor: firstColor }} />
            <SecondColor style={{ backgroundColor: secondColor }} />
          </ContainerCircle>
          <TextNumberOption>{number}</TextNumberOption>
        </ContainerNumber>
        {children}
      </ContainerGradient>
      <ContainerGreenBack style={{ backgroundColor: firstColor }} />
    </ContainerMain>
  );
};

CardInfoOption.propTypes = {
  number: PropTypes.string,
  children: PropTypes.node,
  firstColor: PropTypes.string,
  secondColor: PropTypes.string,
  press: PropTypes.func,
  custom: PropTypes.bool,
};

export default CardInfoOption;
